import React from "react";
import { Result } from "antd";
import warningIcon from "../../images/alert-sign.png";
import { t } from "i18next";
const EmptyOrderHistory = () => {
  return (
    <Result
      icon={<img alt="warning" src={warningIcon} style={{ width: "100px" }} />}
      status="warning"
      title={t("resultsNotFound")}
    />
  );
};

export default EmptyOrderHistory;
